import { Component, ViewChild } from '@angular/core';
import { NgbDateParserFormatter, NgbModal, NgbModule, NgbNav, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ClientgroupMasterServiceService } from '../../Model/ClientGroupMaster/clientgroup-master-service.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule, DecimalPipe, JsonPipe } from '@angular/common';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { UtilityService } from '../../Model/utility/utility.service';
import { PostingOrderService } from '../../posting-order.service';

@Component({
  selector: 'app-client-group-master',
  standalone: true,
  imports: [NgbNavModule, NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, DecimalPipe, CommonModule, LoaderComponent, JsonPipe, DataTablesModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }],
  templateUrl: './client-group-master.component.html',
  styleUrl: './client-group-master.component.scss'
})
export class ClientGroupMasterComponent {
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  @ViewChild('nav') nav!: NgbNav;
  isDisabled: boolean = false;
  active = 1;
  BillToOption: number = 0 as any;
  ControlAccLoad: any[] = [];
  CurrencyLoad: any[] = [];
  PartyTypeDebtorsLoad: any[] = [];
  CityLoad: any[] = [];
  BankNameLoad: any[] = [];
  SectionLoad: any[] = [];
  BranchNameLoad: any[] = [];
  GSTStateLoad: any[] = [];
  GroupLoad: any[] = [];
  AreaLoad: any[] = [];
  AddressTable: any[] = [];
  RateApplicableLoad: any[] = [];
  ClientOwnerLoad: any[] = [];
  MsMeLoad: any[] = [];
  ControlACCode: any = null;
  //RateApplicable: string = ''
  SectionType: string = '';
  TDSOption: string = 'Net';
  TDSvalue: number = 0;
  Active: number = 1;
  BillTo: string = 'Client';
  ShipTo: string = 'Client';
  CustomerType: string = 'Local';
  PlaceOfSupplyOpt: string = 'N';
  CreditLimitOpt: string = 'M';
  AutoBilling: string = '1';
  AutoRoundOff: string = 'N';
  GSTExempt: number = 0;
  SezCustomer: number = 0;
  SezGstExempt: string = 'N';
  CurrencyName: any = null;
  CurrencyCode: string = '';
  CitySelect: string = '';
  CityCode: any = null;
  StateName: string = '';
  StateCode: string = '';
  SectionSelect: string = '';
  SectionName: any = null;
  ControlACSelect: string = '';
  // GroupSelect: string = '';
  GroupId: any = null;
  BranchSelect: string = '';
  BranchID: any = null;
  AreaSelect: string = '';
  AreaName: any = null;
  Email: string = '';
  CreditTerms: string = ''
  CreditDays: any = null;
  PANno: string = '';
  TANno: string = '';
  Address1: string = '';
  Address2: string = '';
  Address3: string = '';
  Address4: string = '';
  VatTinNo: string = '';
  CstTinNo: string = '';

  VatNoDate: any = null;
  VatNoDateObj: any = null;

  CSTNoDate: any = null;
  CSTNoDateObj: any = null;

  DateOfReg: any = null
  DateOfRegObj: any = null;

  DateOfDecl: any = null;
  DateOfDeclObj: any = null;

  BussinessType: any = null;
  GSTNo: string = '';
  ReasonGSTExempt: string = '';
  PartyTypeDebtors: any = null;
  TTlPartyTypeID: any = null
  District: string = '';
  Tel1: any = null;
  Tel2: any = null;
  ZipCode: any = null;
  ContactName: string = '';
  Designation: string = '';
  MobileNo: any = null;
  LandLineNo: any = null;
  ContactPersonEmailID: string = '';
  RCMApplicable: number = 0;
  GSTStateCode: any = null;
  GSTState: string = '';
  SezLetterNo: string = '';
  editMode: boolean = false;
  MSMEClient: number = 0;
  MSMENo: string = '';
  CustomerCode: string = '';
  CustomerName: string = '';
  AdminCharges: number = 0;
  AliasName: string = '';
  WebSite: string = '';
  AlternateCode: string = '';
  AutoMail: number = 0;
  OurBankID: number = 0;
  // BankMarking: any = null;
  CreditLimit: any = null;
  Index: number = 0;
  Commissionerate: string = '';
  Collectorate: string = ''
  NameOfBank: string = '';
  AccountNumber: any = null;
  RTGSCode: string = '';
  MICRCode: string = '';
  Notes: string = '';
  DefaultNarration: string = '';
  // ClientOwner: string = ''
  ClientOwnerID: any = null;
  RateApplicableID: any = null;
  public User: any = null;
  // EditSData: boolean = false;
  MsmeMasterCode: any
  GLCode: string = ''
  Detail = {
    SelectType: 1,
    controlAcc: this.ControlACCode
  }
  Clientdatafrmview = {
    EditSData: false,
    SelectType: 2,
    ClientGroupMasterID: ''
  }
  EditData: any[] = []
  AdressData: any[] = [];

  LowerTDSApplicable = false;
  LowerTDSCertificateNo = '';
  LowerTDSValidFrom = null as any;
  LowerTDSValidTo = null as any;
  LowerTDSPercentage = '';
  LowerTDSAmount = '';
  AgreementAttachment = '';
  AgreementStartDate = null as any;
  AgreementEndDate = null as any;
  IsComplaince = true;
  GSTStateCodeStart = '';
  OfficeTypeLoad = [] as any;
  OfficeType = null as any;

  // dtTrigger: Subject<any> = new Subject<any>();
  dtoptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: true,
    destroy: true,
    pageLength: 10,
    lengthMenu: [10, 25, 50, 100],
    lengthChange: true,
    language: {
      searchPlaceholder: 'Search...',
    },
  };
  constructor(
    private clientgroupservice: ClientgroupMasterServiceService,
    private sessionService: SessionService,
    private toast: ToastService,
    private dateFormate: CustomDateParserFormatter,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private router: Router,
    private utility: UtilityService,
    private posting: PostingOrderService
  ) {
    this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();
    // this.dtoptions = { ...this.common.commonDToptions }; 
  }
  ngOnInit(): void {
    this.LoadOfficeType();
    this.loadSiteData();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  loadSiteData() {
    this.isDisabled = true;
    this.clientgroupservice.ClientComboLoad(this.Detail).subscribe({
      next: (data) => {
        console.log('API Response:', data);
        this.ControlAccLoad = data.ControlAcc;
        this.CurrencyLoad = data.CurrencyMaster;
        if (this.CurrencyLoad.length > 0) {
          const currency = this.CurrencyLoad.find((e: any) => e.CurrencyName == 'INDIAN RUPEES');
          if (currency) {
            this.CurrencyName = currency.CurrencyName;
            this.CurrencyCode = currency.CurrencyCode;
          }
        }
        this.PartyTypeDebtorsLoad = data.PartyTypeDebtors;
        this.CityLoad = data.CityMaster;
        this.BankNameLoad = data.BankMaster;
        this.SectionLoad = data.SalesSectionMaster;
        this.BranchNameLoad = data.BranchNameMaster;
        this.GSTStateLoad = data.GSTStateMaster;
        this.AreaLoad = data.AreaMaster;
        this.RateApplicableLoad = data.RateApplicableMaster;
        this.ClientOwnerLoad = data.UserMaster;
        this.MsMeLoad = data.MSMESECTOR;
        this.isDisabled = false;
      },
      complete: () => {
        this.ProcessData();
      },
      error: (error) => {
        console.error('Error:', error);
      },
    });
  }
  ProcessData() {
    this.route.queryParams.subscribe(params => {
      this.Clientdatafrmview.EditSData = params['editMode'];
      this.Clientdatafrmview.SelectType = params['SelectType'];
      this.Clientdatafrmview.ClientGroupMasterID = params["ClientGroupMasterID"];
    });
    this.isDisabled = true
    this.clientgroupservice.ClientLoad(this.Clientdatafrmview).subscribe(
      data => {
        if (data) {
          this.EditData = data.Table || [];

          this.AdressData = data.Table1 || [];
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });


          if (this.EditData.length > 0) {
            this.CustomerCode = this.EditData[0].CustomerCode;
            this.CustomerName = this.EditData[0].CustomerName;
            this.RateApplicableID = this.EditData[0].RateApplicableId;
            // this.RateApplicable = this.EditData[0].RateApplicableName;
            this.ClientOwnerID = this.EditData[0].ClientOwnerId;
            //this.ClientOwner = this.EditData[0].ClientOwnerName;
            this.AdminCharges = this.EditData[0].AdminChargs;
            this.Active = this.EditData[0].Active;

            this.AliasName = this.EditData[0].AliasName;
            this.Email = this.EditData[0].Email;
            this.WebSite = this.EditData[0].Website;

            this.ControlACCode = this.EditData[0].ControlAccCode;
            this.Detail.controlAcc = this.ControlACCode;
            this.clientgroupservice.ClientComboLoad(this.Detail).subscribe({
              next: (data) => {
                this.ControlAccLoad = data.ControlAcc;
                this.GroupLoad = data.GroupMaster;
              },
              complete: () => {
              },
              error: (error) => {
                console.error('Error:', error);
              },
            });
            this.GroupId = this.EditData[0].DebtIndGroupId;
            this.AutoBilling = (this.EditData[0].AutoBillingSitewiseYesNo == true) ? '1' : '0';
            this.AutoRoundOff = (this.EditData[0].AutoRoundOff == 'Y') ? 'Y' : 'N';
            this.CurrencyCode = this.EditData[0].CurrencyCode;
            this.CurrencyName = this.EditData[0].CurrencyName;
            this.CreditTerms = this.EditData[0].CreditTerms;
            this.CreditDays = this.EditData[0].CreditPeriod;
            this.PANno = this.EditData[0].PANNo;
            this.TANno = this.EditData[0].TANNo;
            this.PartyTypeDebtors = this.EditData[0].TTLPartyTypeCode;
            this.AlternateCode = this.EditData[0].KORECTGLCode;
            //this.SectionType = this.EditData[0].TDS_Comp == false ? '0' : '1'; //verify we get false but save 0 and 1 and null
            // this.SectionType = this.EditData[0].TDS_Comp === '1' ? '1' : (this.EditData[0].TDS_Comp === '0' ? '0' : '');
            this.SectionType = this.EditData[0].TDS_Comp == true ? '1' : this.EditData[0].TDS_Comp == false ? '0' : '';
            this.SectionName = this.SectionLoad.find((e: any) => e.SectionCode == this.EditData[0].TDS194)?.SectionName;;
            this.SectionSelect = this.EditData[0].TDS194;
            this.TDSOption = this.EditData[0].TDSOn;
            this.TDSvalue = this.EditData[0].TDSRoundOff == 'Y' ? 1 : 0;
            this.VatTinNo = this.EditData[0].STRegister;

            const vatnodate = new Date(this.EditData[0].VATDate);
            // this.VatNoDate = this.EditData[0].VATDate != null ? this.dateFormate.parse(this.EditData[0].VATDate) : '';
            this.VatNoDate = this.dateFormate.parse(vatnodate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', }));

            const cstnodate = new Date(this.EditData[0].CSTDate);
            this.CSTNoDate = this.dateFormate.parse(cstnodate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', }));

            this.CstTinNo = this.EditData[0].CSTRegister;
            // this.CSTNoDate = this.EditData[0].CSTDate != null ? this.dateFormate.parse(this.EditData[0].CSTDate) : '';
            this.CreditLimitOpt = this.EditData[0].CreditExceed;
            this.NameOfBank = this.EditData[0].BankName;
            this.AccountNumber = this.EditData[0].AccountNumber;
            this.RTGSCode = this.EditData[0].RTGSCode;
            this.MICRCode = this.EditData[0].MICRCode;
            this.BillTo = this.EditData[0].BillTo;
            this.ShipTo = this.EditData[0].ShipTo;
            this.OurBankID = this.EditData[0].BankMarking;
            // this.BankMarking = this.EditData[0].BankName;
            this.CreditLimit = this.EditData[0].CreditLimit;
            this.CustomerType = this.EditData[0].CustomerType;
            this.AutoMail = this.EditData[0].AutoMail;
            this.PlaceOfSupplyOpt = (this.EditData[0].PlaceOfSupplyApplicable == 'Y') ? 'Y' : 'N';
            this.Commissionerate = this.EditData[0].CentralExciseCommissionRate;
            this.Collectorate = this.EditData[0].ExciseCollectorate;
            this.MsmeMasterCode = this.EditData[0].MSMESector;
            this.MSMENo = this.EditData[0].MSMENo;

            this.LowerTDSApplicable = this.EditData[0].LowerTDSApplicable;
            this.LowerTDSCertificateNo = this.EditData[0].LowerTDSCertificateNo;

            const lowertdsvalidfrom = new Date(this.EditData[0].LowerTDSValidFrom);
            this.LowerTDSValidFrom = this.dateFormate.parse(lowertdsvalidfrom.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', }));

            const lowertdsvalidto = new Date(this.EditData[0].LowerTDSValidTo);
            this.LowerTDSValidTo = this.dateFormate.parse(lowertdsvalidto.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', }));

            const agreementstartdate = new Date(this.EditData[0].AgreementStartDate);
            this.AgreementStartDate = this.dateFormate.parse(agreementstartdate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', }));

            const agreementenddate = new Date(this.EditData[0].AgreementEndDate);
            this.AgreementEndDate = this.dateFormate.parse(agreementenddate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', }));

            this.LowerTDSPercentage = this.EditData[0].LowerTDSPercentage;
            this.LowerTDSAmount = this.EditData[0].LowerTDSAmount;
            this.AgreementAttachment = this.EditData[0].AgreementAttachment;
            this.AttachmentUrl = 'https://webftp.maxus.co.in/PROD/ClientAgreementDetail/' + this.EditData[0].AgreementAttachment;

            if (this.MSMENo != '') {
              this.MSMEClient = 1
            }

            const dateofreg = new Date(this.EditData[0].MSMEDateOfRegistration);
            this.DateOfReg = this.dateFormate.parse(dateofreg.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', }));

            const dateofdecl = new Date(this.EditData[0].MSMEDateOfDeclaration);
            this.DateOfDecl = this.dateFormate.parse(dateofdecl.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', }))

            // this.DateOfReg = this.EditData[0].MSMEDateOfRegistration != null ? this.dateFormate.parse(this.EditData[0].MSMEDateOfRegistration) : '';
            // this.DateOfDecl = this.EditData[0].MSMEDateOfDeclaration != null ? this.dateFormate.parse(this.EditData[0].MSMEDateOfDeclaration) : '';
            this.Notes = this.EditData[0].Notes;
            this.DefaultNarration = this.EditData[0].DefaultNarration;
            this.IsComplaince = this.EditData[0].IsComplaince;
            this.OfficeType = this.EditData[0].OfficeType == 0 ? null : this.EditData[0].OfficeType;
          }
          if (this.AdressData.length > 0) {
            this.AddressTable = this.AdressData
          }
          this.isDisabled = false
        }
      },
      error => {
        this.isDisabled = false
        console.error('Error:', error);
      }
    );
  }
  goToNextTab(type: string): void {
    const currentActiveId = this.nav.activeId;
    if (type === 'Tab1') {
      if (this.CustomerName == '') {
        this.toast.show({ message: 'Please enter Customer Name.', type: toastTypeEnum.warning });
        return
      }
    }
    else if (type === 'Tab2') {

      if (!this.isValidPAN(this.PANno) && this.PANno.trim() !== '') {
        this.toast.show({ message: 'Enter valid PAN number.', type: toastTypeEnum.warning });
        return;
      }

      if (!this.isValidTAN(this.TANno) && this.TANno.trim() !== '') {
        this.toast.show({ message: 'Enter valid TAN number.', type: toastTypeEnum.warning });
        return;
      }

      if (this.ControlACCode == '' || this.ControlACCode == null) {
        this.toast.show({ message: 'Please Select Control Account.', type: toastTypeEnum.warning });
        return
      }
      if (this.CurrencyName == '') {
        this.toast.show({ message: 'Please Select Currency Code.', type: toastTypeEnum.warning });
        return
      }
      if (this.PartyTypeDebtors == '' || this.PartyTypeDebtors == null) {
        this.toast.show({ message: 'Please select Party Type.', type: toastTypeEnum.warning });
        return;
      }
    }
    else if (type === 'Tab3') {
      if (!this.isValidEmailList(this.Email) && this.Email.trim() !== '') {
        this.toast.show({ message: 'Enter Valid Party Email', type: toastTypeEnum.warning });
        return;
      }
      if (!this.isValidEmailList(this.ContactPersonEmailID) && this.ContactPersonEmailID.trim() !== '') {
        this.toast.show({ message: 'Enter Valid Contact Person Email', type: toastTypeEnum.warning });
        return;
      }
      if (!this.isValidGST(this.GSTNo) && this.GSTNo.trim() !== '') {
        this.toast.show({ message: 'Enter Valid GST No', type: toastTypeEnum.warning });
        return;
      }
      if ((this.GSTNo.trim() !== '') && this.GSTStateCode !== this.GSTNo.slice(0, 2)) {
        this.toast.show({ message: 'GST State Code not matching with GST Number', type: toastTypeEnum.warning });
        return;
      }
    }
    if (currentActiveId < 5) {
      this.nav.select(currentActiveId + 1);
    }
  }
  onSelectChange(type: string) {
    // if (type == 'RateApplicable') {
    //   const selected = this.RateApplicableLoad.find(data => data.RateApplicableID === this.RateApplicableID);
    //   this.RateApplicable = selected ? selected.RateApplicableName : null;
    // }
    // else if (type === 'ClientOwner') {
    //   const selected = this.ClientOwnerLoad.find(data => data.UserMasterID === this.ClientOwnerID);
    //   this.ClientOwner = selected ? selected.UserName : null;
    // }
    //else 
    if (type === 'ControlAc') {
      const selected = this.ControlAccLoad.find(data => data.GLCode === this.ControlACCode);
      this.ControlACSelect = selected ? selected.GLName : null;
      this.Detail.controlAcc = this.ControlACCode;
      this.clientgroupservice.ClientComboLoad(this.Detail).subscribe({
        next: (data) => {
          this.ControlAccLoad = data.ControlAcc;
          this.GroupLoad = data.GroupMaster;
        },
        complete: () => {
        },
        error: (error) => {
          console.error('Error:', error);
        },
      });
      this.GroupId = null;
    }
    // else if (type === 'Group') {
    //   const selected = this.GroupLoad.find(data => data.id === this.GroupId);
    //   this.GroupSelect = selected ? selected.GroupName : null;
    // }
    // else if (type === 'CurrencyLoad') {
    //   const selected = this.CurrencyLoad.find(data => data.CurrencyName === this.CurrencyName);
    //   this.CurrencyCode = selected ? selected.CurrencyCode : null;
    // }
    else if (type === 'Branch') {
      const selected = this.BranchNameLoad.find(data => data.DivisionCode === this.BranchID);
      this.BranchSelect = selected ? selected.DivisionName : null;
    }
    else if (type === 'CityLoad') {
      const selected = this.CityLoad.find(data => data.CityCode === this.CityCode);
      this.CitySelect = selected ? selected.CityName : null;
      this.StateName = selected ? selected.StateName : null;
      this.StateCode = selected ? selected.StateCode : null;
    }
    else if (type === 'Area') {
      const selected = this.AreaLoad.find(data => data.AreaName === this.AreaName);
      this.AreaSelect = selected ? selected.AreaCode : null;
    }
    else if (type === 'GSTSelect') {
      const selected = this.GSTStateLoad.find(data => data.GSTStateCode === this.GSTStateCode);
      this.GSTState = selected ? selected.GSTStateName : null;
      // this.GSTStateCodeStart = selected ? selected.GSTStateCode : '';
    }
    else if (type === 'SectionSelect') {
      const selected = this.SectionLoad.find(data => data.SectionName === this.SectionName);
      this.SectionSelect = selected ? selected.SectionCode : null;
    }
    // else if (type === 'BankMarking') {
    //   const selected = this.BankNameLoad.find(data => data.OurCompanyBankMasterID === this.OurBankID);
    //   this.BankMarking = selected ? selected.BankName : null;
    // }
    // else if (type === 'PartyTypeDebtorsLoad') {
    //   const selected = this.PartyTypeDebtorsLoad.find(data => data.TTLPartyTypeId === this.TTlPartyTypeID);
    //   this.PartyTypeDebtors = selected ? selected.TTLPartyTypeCode : null;
    // }
    else if (type === 'businesstype') {
      this.GSTNo = ''
    }
  }
  checkboxChanged(type: string) {
    if (type == 'GSTExempt') {
      if (this.GSTExempt == 0) {
        this.ReasonGSTExempt = ''
      }
    }
    else if (type == 'SezCust') {
      if (this.SezCustomer == 0) {
        this.SezGstExempt = 'N'
        this.SezLetterNo = ''
      }
    }
    else if (type == 'BillToShipTo') {
      if (this.BillToOption == 0) {
        this.BillTo = 'Client'
        this.ShipTo = 'Client'
      }
    }
    else if (type == 'MSMEClient') {
      if (this.MSMEClient == 0) {
        this.MSMENo = ''
        this.DateOfReg = null;
        this.DateOfRegObj = null;
        this.DateOfDecl = null;
        this.DateOfDeclObj = null;
        this.MsmeMasterCode = null;
      }
    }
  }
  Add() {
    if (this.BranchSelect == '') {
      this.toast.show({ message: 'Please Select Branch.', type: toastTypeEnum.warning });
      return
    }
    const existingBranch = this.AddressTable.findIndex(branch => branch.Branch === this.BranchSelect);
    if (!this.editMode) {
      if (existingBranch !== -1) {
        this.toast.show({ message: 'Branch Already Exists. Please choose a different branch.', type: toastTypeEnum.warning });
        return
      }
    }
    if (this.Address1 == '') {
      this.toast.show({ message: 'Please enter Address.', type: toastTypeEnum.warning });
      return
    }
    // if (this.ContactPersonEmailID != '') {
    //   const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    //   if (!emailPattern.test(this.ContactPersonEmailID)) {
    //     this.toast.show({ message: 'Please enter a valid Email Address.', type: toastTypeEnum.warning });
    //     return;
    //   }
    // }
    if (this.AreaSelect == '') {
      this.toast.show({ message: 'Please Select Area Name.', type: toastTypeEnum.warning });
      return
    }
    if (this.BussinessType == '' || this.BussinessType == null) {
      this.toast.show({ message: 'Please Select Bussiness Type.', type: toastTypeEnum.warning });
      return
    }
    if (this.GSTStateCode == '' || this.GSTStateCode == null) {
      this.toast.show({ message: 'Please Select GST State Code.', type: toastTypeEnum.warning });
      return
    }
    if ((this.BussinessType == 'R' || this.BussinessType == 'P') && this.GSTNo == '') {
      this.toast.show({ message: 'Please enter GST NO.', type: toastTypeEnum.warning });
      return
    }

    const gstNoPrefix = this.GSTNo ? this.GSTNo.substring(0, 2) : null;
    const gstStateCodePrefix = this.GSTStateCode ? this.GSTStateCode.substring(0, 2) : null;

    if ((this.BussinessType == 'R' || this.BussinessType == 'P') && gstNoPrefix !== gstStateCodePrefix) {
      this.toast.show({ message: 'GST NO doest match with the state code.', type: toastTypeEnum.warning });
      return
    }
    if (this.GSTExempt == 1 && this.ReasonGSTExempt == '') {
      this.toast.show({ message: 'Please Provide Reason For GST Exempt.', type: toastTypeEnum.warning });
      return
    }
    if ((this.GSTExempt === 1 && this.ReasonGSTExempt === '') && this.editMode) {
      this.toast.show({ message: 'Please Provide Reason For GST Exempt.', type: toastTypeEnum.warning });
      return;
    }
    if (this.SezGstExempt == 'Y') {
      if (this.SezLetterNo == '') {
        this.toast.show({ message: 'Please Enter Sez Letter No.', type: toastTypeEnum.warning });
        return;
      }
    }
    var BranchCode = this.BranchID;
    var Branch = this.BranchSelect;
    var Address1 = this.Address1;
    var Address2 = this.Address2;
    var Address3 = this.Address3;
    var Address4 = this.Address4;

    var CityCode = this.CityCode;
    var CityName = this.CitySelect;
    var DistrictName = this.District;
    var StateName = this.StateName;
    var TelephoneNo = this.Tel1;
    var TelephoneNo2 = this.Tel2;
    var PinCode = this.ZipCode;
    var ContactPerson = this.ContactName;
    var Designation = this.Designation;
    var ContactPersonMobileNo = this.MobileNo;
    var ContactPersonLandlineNo = this.LandLineNo;
    var ContactPersonEmailID = this.ContactPersonEmailID;
    var AreaCode = this.AreaSelect;
    var AreaName = this.AreaName;
    var BusinessType = this.BussinessType;

    var GSTStateCode = this.GSTStateCode;
    var GSTState = this.GSTState;
    var GSTNo = this.GSTNo;
    var GSTExempt = this.GSTExempt ? 'Y' : 'N';
    var GSTExemptReason = this.ReasonGSTExempt;
    var SEZCustomer = this.SezCustomer ? 'Y' : 'N';
    var SEZGSTExempt = this.SezGstExempt;

    var SEZLetterNo = this.SezLetterNo;
    var RCMApplicable = this.RCMApplicable ? 'Y' : 'N';
    var GLCode = this.GLCode;

    var BillTo = this.BillTo;
    var ShipTo = this.ShipTo;
    var PlaceOfSupplyApplicable = this.PlaceOfSupplyOpt;

    var Address = {
      BranchCode: BranchCode,
      Branch: Branch,
      Address1: Address1,
      Address2: Address2,
      Address3: Address3,
      Address4: Address4,
      CityCode: CityCode,
      CityName: CityName,
      DistrictName: DistrictName,
      StateName: StateName,
      TelephoneNo: TelephoneNo,
      TelephoneNo2: TelephoneNo2,
      PinCode: PinCode,
      ContactPerson: ContactPerson,
      Designation: Designation,
      ContactPersonMobileNo: ContactPersonMobileNo,
      ContactPersonLandlineNo: ContactPersonLandlineNo,
      ContactPersonEmailID: ContactPersonEmailID,
      AreaCode: AreaCode,
      AreaName: AreaName,
      BusinessType: BusinessType,
      GSTStateCode: GSTStateCode,
      GSTState: GSTState,
      GSTNo: GSTNo,
      GSTExempt: GSTExempt,
      GSTExemptReason: GSTExemptReason,
      SEZCustomer: SEZCustomer,
      SEZGSTExempt: SEZGSTExempt,
      SEZLetterNo: SEZLetterNo,
      RCMApplicable: RCMApplicable,
      GLCode: GLCode,
      BillTo: BillTo,
      ShipTo: ShipTo,
      PlaceOfSupplyApplicable: PlaceOfSupplyApplicable
    };
    if (this.editMode) {
      //this.AddressTable[this.Index] = Address;
      this.AddressTable[this.Index] = {
        ...this.AddressTable[this.Index],
        ...Address
      };
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      // console.log(this.AddressTable);

    } else {
      this.AddressTable.push(Address);
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    }
    this.resetForm();
  }
  onSelectionChange() {
    if (this.SectionType == '') {
      this.SectionSelect = 'Select';
      this.SectionName = '';
      this.TDSOption = 'Net'
      this.TDSvalue = 0;
    }
  }
  onEditClick(element: any, index: number): void {
    this.Index = index;
    this.editMode = true;
    this.BranchID = element.DivisionCode;
    this.BranchSelect = element.Branch;
    this.Address1 = element.Address1;
    this.Address2 = element.Address2;
    this.Address3 = element.Address3;
    this.Address4 = element.Address4;
    this.CityCode = element.CityCode;
    this.CitySelect = element.CityName;
    this.District = element.DistrictName;
    this.StateName = element.StateName;
    this.onSelectChange('CityLoad');
    this.Tel1 = element.TelephoneNo;
    this.Tel2 = element.TelephoneNo2;
    this.ZipCode = element.PinCode;
    this.ContactName = element.ContactPerson;
    this.Designation = element.Designation;
    this.MobileNo = element.ContactPersonMobileNo;
    this.LandLineNo = element.ContactPersonLandlineNo;
    this.ContactPersonEmailID = element.ContactPersonEmailID;
    this.AreaSelect = element.AreaCode;
    this.AreaName = element.AreaName;
    this.BussinessType = element.BusinessType;
    this.GSTStateCode = element.GSTStateCode;
    this.GSTState = element.GSTState;
    this.GSTNo = element.GSTNo;
    this.GSTExempt = element.GSTExempt === 'Y' ? 1 : 0;
    this.ReasonGSTExempt = element.GSTExemptReason;
    this.SezCustomer = element.SEZCustomer === 'Y' ? 1 : 0;
    this.SezGstExempt = element.SEZGSTExempt;
    this.SezLetterNo = element.SEZLetterNo;
    this.RCMApplicable = element.RCMApplicable === 'Y' ? 1 : 0;
    this.GLCode = element.GLCode;
    this.BillTo = element.BillTo;
    this.ShipTo = element.ShipTo;
    this.BillToOption = element.BillTo == '' ? 0 : 1;
    this.PlaceOfSupplyOpt = element.PlaceOfSupplyApplicable;
  }

  async save() {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      //centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you Sure want to save?'

    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsEdit || this.common.PageRight.IsAdd) {
        if (result) {
          this.SaveandUpdate();
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {

    });
  }
  SaveandUpdate() {
    if (this.CustomerName == '') {
      this.toast.show({ message: 'Please enter Customer Name.', type: toastTypeEnum.warning });
      return
    }
    // if (this.Email == "") {
    //   this.toast.show({ message: 'Please enter Email Address in Basic Details.', type: toastTypeEnum.warning });
    //   return
    // }
    // const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // if (!emailPattern.test(this.Email)) {
    //   this.toast.show({ message: 'Please enter a valid Email Address.', type: toastTypeEnum.warning });
    //   return;
    // }
    if (this.ControlACCode == '' || this.ControlACCode == null) {
      this.toast.show({ message: 'Please Select Control Account in Basic Details.', type: toastTypeEnum.warning });
      return
    }
    if (this.CurrencyName == '') {
      this.toast.show({ message: 'Please Select Currency Code in Basic Details.', type: toastTypeEnum.warning });
      return
    }
    if (this.PartyTypeDebtors == '' || this.PartyTypeDebtors == null) {
      this.toast.show({ message: 'Please select Party Type in Basic Details.', type: toastTypeEnum.warning });
      return
    }
    if (this.VatTinNo != '') {
      if (!this.VatNoDate) {
        this.toast.show({ message: 'Please enter VAT Date in Additional Details.', type: toastTypeEnum.warning });
        return
      }
    }
    if (this.CstTinNo != '') {
      if (!this.CSTNoDate) {
        this.toast.show({ message: 'Please enter CST Date in Additional Details.', type: toastTypeEnum.warning });
        return
      }
    }

    if (this.MSMEClient == 1) {
      if (this.MSMENo == '') {
        this.toast.show({ message: 'Please enter MSME No in Additional Details.', type: toastTypeEnum.warning });
        return
      }
      if (this.MsmeMasterCode == '') {
        this.toast.show({ message: 'Please Select MSME Type in Additional Details.', type: toastTypeEnum.warning });
        return
      }
      if (!this.DateOfReg) {
        this.toast.show({ message: 'Please enter Date of registration in Additional Details.', type: toastTypeEnum.warning });
        return
      }
      if (!this.DateOfDecl) {
        this.toast.show({ message: 'Please enter Date of declaration in Additional Details.', type: toastTypeEnum.warning });
        return
      }

      if (!this.isValidPAN(this.PANno) && this.PANno.trim() !== '') {
        this.toast.show({ message: 'Enter valid PAN number.', type: toastTypeEnum.warning });
        return;
      }

      if (!this.isValidTAN(this.TANno) && this.TANno.trim() !== '') {
        this.toast.show({ message: 'Enter valid TAN number.', type: toastTypeEnum.warning });
        return;
      }

      if (!this.isValidEmailList(this.Email) && this.Email.trim() !== '') {
        this.toast.show({ message: 'Enter Valid Party Email', type: toastTypeEnum.warning });
        return;
      }

      if (!this.isValidEmailList(this.ContactPersonEmailID) && this.ContactPersonEmailID.trim() !== '') {
        this.toast.show({ message: 'Enter Valid Contact Person Email', type: toastTypeEnum.warning });
        return;
      }

      if (!this.isValidGST(this.GSTNo) && this.GSTNo.trim() !== '') {
        this.toast.show({ message: 'Enter Valid GST No', type: toastTypeEnum.warning });
        return;
      }

      if ((this.GSTNo.trim() !== '') && this.GSTStateCode !== this.GSTNo.slice(0, 2)) {
        this.toast.show({ message: 'GST State Code not matching with GST Number', type: toastTypeEnum.warning });
        return;
      }

      // const RegDate = new Date(this.DateOfRegObj);
      // const DeclDate = new Date(this.DateOfDeclObj);
      // if (DeclDate <= RegDate) {
      //   this.toast.show({ message: 'Declaration date must be greater than Registration Date!', type: toastTypeEnum.warning });
      //   return
      // }
    }
    this.User = this.sessionService.GetUserDetails();

    this.VatNoDateObj = this.dateFormate.format(this.VatNoDate);
    this.CSTNoDateObj = this.dateFormate.format(this.CSTNoDate);
    this.DateOfRegObj = this.dateFormate.format(this.DateOfReg);
    this.DateOfDeclObj = this.dateFormate.format(this.DateOfDecl);
    this.isDisabled = true
    const essclientAddressData = this.AddressTable.map(address => {
      return {
        BranchCode: address.BranchCode || '',
        Address1: address.Address1 || '',
        Address2: address.Address2 || '',
        Address3: address.Address3 || '',
        Address4: address.Address4 || '',
        CityCode: address.CityCode || '',
        District: address.DistrictName || '',
        State: address.StateName || '',
        TelephoneNo: address.TelephoneNo || '',
        TelephoneNo2: address.TelephoneNo2 || '',
        PinCode: address.PinCode || '',
        ContactPerson: address.ContactPerson || '',
        Designation: address.Designation || '',
        ContactPersonLandlineNo: address.ContactPersonLandlineNo || '',
        ContactPersonEmailID: address.ContactPersonEmailID || '',
        GSTNo: address.GSTNo || '',
        AreaCode: address.AreaCode || '',
        GSTStateCode: address.GSTStateCode || '',
        BusinessType: address.BusinessType || '',
        GSTExempt: address.GSTExempt, //== false ? 'N' : 'Y' || '',
        GSTExemptReason: address.GSTExemptReason || '',
        SEZCustomer: address.SEZCustomer,//== false ? 'N' : 'Y' || '',
        SEZGSTExempt: address.SEZGSTExempt || '', // == 'No'? 'N' : 'Y',
        SEZLetterNo: address.SEZLetterNo || '',
        RCMApplicable: address.RCMApplicable,//== false ? 'N' : 'Y' || '',
        GLCode: address.GLCode || '',
        ContactPersonMobileNo: address.ContactPersonMobileNo || ''
      };
    });

    const ClientIndertUpdate = {
      SelectType: this.Clientdatafrmview.EditSData ? 2 : 1,
      ID: this.Clientdatafrmview.ClientGroupMasterID,
      Code: this.CustomerCode,
      ClientGroupName: this.CustomerName,
      ClientOwnerID: this.ClientOwnerID,
      RateApplicableId: this.RateApplicableID,
      IsAdminChargesApplicable: (this.AdminCharges == 1) ? true : false,
      Active: (this.Active == 1) ? true : false,
      AliasName: this.AliasName,
      Email: this.Email,
      Website: this.WebSite,
      ControlAccCode: this.ControlACCode,
      ClientGroupId: 0,//this.GroupId,
      OptYes: this.AutoBilling,
      AutoRoundOff: this.AutoRoundOff,
      CurrencyCode: this.CurrencyCode,
      CreditTerms: this.CreditTerms,
      CreditPeriod: this.CreditDays,
      PANNo: this.PANno,
      TANNo: this.TANno,
      DebtIndGroupId: this.GroupId,//this.TTlPartyTypeID,
      TTLPartyTypeCode: this.PartyTypeDebtors,
      ESS_ClientMasterAddressDetails: essclientAddressData,
      TDS_Comp: (this.SectionType == '') ? null : this.SectionType,
      TDS194: this.SectionSelect,
      TDSOn: this.TDSOption,
      TDSRoundOff: (this.TDSvalue == 1) ? 'Y' : 'N',
      AutoMail: (this.AutoMail == 1) ? '1' : '0',
      STRegister: this.VatTinNo,
      VATDate: this.VatNoDateObj, //this.formatDateObject(this.VatNoDate),
      CSTRegister: this.CstTinNo,
      CSTDate: this.CSTNoDateObj, //this.formatDateObject(this.CSTNoDate),
      BillTo: this.BillTo,
      ShipTo: this.ShipTo,
      BankMarking: this.OurBankID,
      CreditLimit: this.CreditLimit,
      CustomerType: this.CustomerType,
      PlaceOfSupplyApplicable: this.PlaceOfSupplyOpt,
      CreditExceed: this.CreditLimitOpt,
      CentralExciseCommissionRate: this.Commissionerate,
      ExciseCollectoRate: this.Collectorate,
      BankName: this.NameOfBank,
      AccountNumber: this.AccountNumber,
      RTGSCode: this.RTGSCode,
      MICRCode: this.MICRCode,
      MSMENo: this.MSMENo, //(this.MSMEClient == 1) ? 'Y' : 'N',
      DateOfRegistration: this.DateOfRegObj, //this.formatDateObject(this.DateOfReg),
      DateOfDeclaration: this.DateOfDeclObj, // this.formatDateObject(this.DateOfDecl),
      Notes: this.Notes,
      DefaultNarration: this.DefaultNarration,
      By: this.User.UserId,
      MSMESector: this.MsmeMasterCode,
      KorectGLCode: this.AlternateCode,
      LowerTDSApplicable: this.LowerTDSApplicable,
      LowerTDSCertificateNo: this.LowerTDSApplicable ? this.LowerTDSCertificateNo : '',
      LowerTDSValidFrom: this.LowerTDSApplicable ? this.dateFormate.format(this.LowerTDSValidFrom) : '',
      LowerTDSValidTo: this.LowerTDSApplicable ? this.dateFormate.format(this.LowerTDSValidTo) : '',
      LowerTDSPercentage: this.LowerTDSApplicable ? this.LowerTDSPercentage : '',
      LowerTDSAmount: this.LowerTDSApplicable ? this.LowerTDSAmount : '',
      AgreementAttachment: this.AgreementAttachment,
      AgreementStartDate: this.dateFormate.format(this.AgreementStartDate),
      AgreementEndDate: this.dateFormate.format(this.AgreementEndDate),
      IsComplaince: this.IsComplaince,
      OfficeType: this.OfficeType
    }
    this.clientgroupservice.ClientGroupInserUpdate(ClientIndertUpdate).subscribe(
      data => {
        if (data.Error_Code == '01') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = 'Client Group Details Saved Successfully';
          modalRef.result.then((result: any) => {
            if (result) {
              this.router.navigate(['master/ClientView']);
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false
      });
    // this.editMode = false;
    // this.resetForm();
  }
  resetForm() {
    this.editMode = false
    this.GLCode = ''
    this.BranchID = null
    this.BranchSelect = ''
    this.Address1 = ''
    this.Address2 = ''
    this.Address3 = ''
    this.Address4 = ''
    this.CityCode = null
    this.CitySelect = ''
    this.District = ''
    this.StateCode = ''
    this.Tel1 = ''
    this.Tel2 = ''
    this.ZipCode = ''
    this.ContactName = ''
    this.Designation = ''
    this.MobileNo = ''
    this.LandLineNo = ''
    this.ContactPersonEmailID = ''
    this.AreaSelect = ''
    this.AreaName = null
    this.BussinessType = null
    this.GSTStateCode = null
    this.StateName = ''
    this.GSTState = ''
    this.GSTNo = ''
    this.GSTExempt = 0
    this.ReasonGSTExempt = ''
    this.SezCustomer = 0
    this.SezGstExempt = '0'
    this.SezLetterNo = ''
    this.RCMApplicable = 0
    this.BillToOption = 0
    this.PlaceOfSupplyOpt = ''
    this.IsComplaince = true;
  }

  filterInput(event: any) {
    const value = event.target.value;
    event.target.value = value.replace(/[^0-9]/g, '');
  }

  close() {
    this.router.navigate(['master/ClientView']);
  }

  onKeyPressPercentage(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const currentValue = input.value;
    const key = event.key;

    // Allow control keys
    const controlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (controlKeys.includes(key)) return;

    // Allow only digits and dot
    if (!/^[0-9.]$/.test(key)) {
      event.preventDefault();
      return;
    }

    // Prevent more than one dot
    if (key === '.' && currentValue.includes('.')) {
      event.preventDefault();
      return;
    }

    // Predict new value after key press
    const newValue = currentValue + key;

    // Prevent value > 100
    if (parseFloat(newValue) > 100) {
      event.preventDefault();
      return;
    }

    // Prevent more than 2 decimal places
    if (newValue.includes('.')) {
      const decimalPart = newValue.split('.')[1];
      if (decimalPart && decimalPart.length > 2) {
        event.preventDefault();
      }
    }
  }

  onKeyPressAmount(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const currentValue = input.value;
    const key = event.key;

    // Allow editing/navigation keys
    const controlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (controlKeys.includes(key)) return;

    // Allow only numbers and decimal point
    if (!/^[0-9.]$/.test(key)) {
      event.preventDefault();
      return;
    }

    // Prevent more than one decimal point
    if (key === '.' && currentValue.includes('.')) {
      event.preventDefault();
      return;
    }

    // Predict the value after typing
    const newValue = currentValue + key;

    // Block more than 2 decimal places
    if (newValue.includes('.')) {
      const decimalPart = newValue.split('.')[1];
      if (decimalPart && decimalPart.length > 2) {
        event.preventDefault();
        return;
      }
    }
  }

  onFileSelected(event: any) {
    this.isDisabled = true;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
    if (this.selectedFile) {
      this.uploadToFTP(this.selectedFile);
      this.isDisabled = false;
    } else {
      this.isDisabled = false;
    }
  }

  AttachmentUrl = '';
  selectedFile: File | null = null;

  uploadToFTP(file: File) {
    if (!file) {
      return;
    }
    this.isDisabled = true;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.utility.Upload({ 'DomainName': this.User.Domain, 'folder': 'ClientAgreementDetail', 'CompanyCode': this.User.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
        if (response.FileName != "") {
          this.AgreementAttachment = response.FileName;
          this.AttachmentUrl = response.Url;
          this.isDisabled = false;
        } else {
          this.toast.show({ message: 'File not uploaded to FTP', type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
      }, (error) => {
        console.error('FTP Upload Error:', error);
        this.isDisabled = false;
      });
    };
  }

  removeFile() {
    this.selectedFile = null;
    this.AgreementAttachment = '';
    const fileInput = document.getElementById('formFileSm') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
  viewFile() {
    window.open(this.AttachmentUrl, '_blank');
  }

  loadCurrencyName() {
    this.CurrencyName = this.CurrencyLoad.find((e: any) => e.CurrencyCode == this.CurrencyCode).CurrencyName;
  }

  isValidPAN(pan: any) {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/i;
    return panRegex.test(pan);
  }

  isValidTAN(tan: any) {
    const panRegex = /^[A-Z]{4}[0-9]{5}[A-Z]$/i;
    return panRegex.test(tan);
  }

  isValidEmailList(input: any) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}([;,]\s*[^\s@]+@[^\s@]+\.[^\s@]{2,})*$/;
    return emailRegex.test(input);
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  isValidGST(gst: any) {
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][A-Z0-9][Zz][A-Z0-9]$/i;
    return gstRegex.test(gst);
  }

  preventPaste(event: ClipboardEvent) {
    event.preventDefault();
  }

  LoadOfficeType() {
    this.posting.FillCombo({
      SelectType: 'OfficeTypeMaster',
      BranchID: 0
    }).subscribe({
      next: (data) => {
        this.OfficeTypeLoad = data.Table;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
      },
    });
  }

}